const sliderCollection = new Swiper('.slider-collection', {
  slidesPerView: 1,
  spaceBetween: 50,
  loop: false,
  breakpoints: {
    320:{
      slidesPerView: 1,
    },
    480:{
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    1020:{
      slidesPerView: 4,
    }
  },
  navigation: {
    nextEl: '.swiper-collection-button-next',
    prevEl: '.swiper-collection-button-prev'
  },
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
  },
});


sliderCollection.on("reachEnd", e => {

  const next = document.querySelector(".swiper-collection-button-next");
  next.classList.add("hidden");

})

sliderCollection.on("reachBeginning", e => {

  const prev = document.querySelector(".swiper-collection-button-prev");
  prev.classList.add("hidden");

})

sliderCollection.on("fromEdge", e => {

  const prev = document.querySelector(".swiper-collection-button-prev");
  const next = document.querySelector(".swiper-collection-button-next");
  prev.classList.remove("hidden");
  next.classList.remove("hidden");

})